import React from "react";

const BeginnerDisclaimer: React.FC = () => (
  <div className="bg-neutral text-white rounded-[18px] px-6 py-5 mb-[18px]">
    <h3 className="font-dm text-[18px] text-white font-semibold m-0 mb-1.5">
      One thing every beginner must understand
    </h3>
    <p className="text-[14px] text-white/70 font-dm m-0 leading-relaxed">
      Scoring well on fundamentals is <em>not</em> a promise the price will
      rise. A great company can have a flat or falling share price for years. We
      show you the reasoning so you can decide for yourself, but we never tell
      you to buy.
    </p>
  </div>
);

export default BeginnerDisclaimer;
